import { motion } from "framer-motion";
import { cn } from "lib/utils";
import LoadingSpinner from "components/loading-spinner";
import { forwardRef } from "react";

const Modal = forwardRef(function Modal(
  {
    children,
    setModalOpen,
    modalOpen,
    className,
    isLoading = null,
    loadingMessage = null,
    loadingSubtitle = null,
    ...props
  },
  ref
) {
  return (
    <div className="fixed w-screen h-screen top-0 left-0 z-50">
      <motion.div
        className="bg-[#000000b6] w-full h-full fixed top-0 left-0"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        onClick={() => {
          if (!props.disableBackdropClick) setModalOpen(false);
        }}
      ></motion.div>
      <motion.div
        ref={ref}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.2 }}
        className={cn(
          "bg-white rounded-xl mt-[5vh] w-[min(500px,90vw)] mx-auto overflow-scroll p-6 relative overflow-y-auto scrollbar-hide",
          className
        )}
        {...props}
      >
        {isLoading && (
          <div className="absolute top-0 left-0 right-0 bottom-0 h-full w-full flex items-center justify-center bg-white z-20">
            <LoadingSpinner
              isLoading={loadingMessage}
              subtitle={loadingSubtitle}
            />
          </div>
        )}
        {children}
      </motion.div>
    </div>
  );
});

export default Modal;
